import { render, staticRenderFns } from "./FulltextSearch.vue?vue&type=template&id=23a7b7b9&scoped=true"
import script from "./FulltextSearch.vue?vue&type=script&lang=js"
export * from "./FulltextSearch.vue?vue&type=script&lang=js"
import style0 from "./FulltextSearch.vue?vue&type=style&index=0&id=23a7b7b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a7b7b9",
  null
  
)

export default component.exports